module.exports = __webpack_public_path__ + "img/40.77ec07ea.jpg";